import {
 useState
} from 'react';
import {
 RoutingProvider
} from './components/RoutingContext';
import {
 TableSidebar
} from './components/TableSidebar';
import {
 TableHeader
} from './components/TableHeader';
import {
 Outlet
} from 'react-router-dom';

// Main content component that renders based on current route
const MainContent: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);

    return (
        <div className="flex h-full flex-col overflow-hidden w-full">
            <TableHeader onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
            <div className="flex flex-1 overflow-hidden">
                {sidebarOpen && <TableSidebar />}
                <div className="flex flex-1 flex-col overflow-hidden">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

// Wrap the app with the routing provider
const App: React.FC = () => {
    return (
        <RoutingProvider>
            <MainContent />
        </RoutingProvider>
    );
};

export default App;
